export default __webpack_public_path__ + "static/BigLogoBlack-c96f948bebf6b0e6fdc5e6a8f678cff1.svg";